export default "__VITE_ASSET__BahCbCgH__"